<div class="main-footer">
  <div class="logo-wrapper"><img src="../../../../assets/media/images/logo.svg" alt="logo" title="logo"/></div>
  <div class="text-wrapper"><a href="//www.cavallino-bianco.com" target="_blank">Powered by Cavallino Bianco &copy;</a></div>
</div>
